import React, { useEffect, useState } from "react";
import { compose } from "redux";
import { withAuth, withTitle } from "../../HoC";
import { getRequest, deleteRequest } from "../../services/Requests";
import { Button } from "../button";

import style from "./style.module.scss";

export const Debug = () => {
  const [ resp, setresp ] = useState([]);

  const clearData = async () => {
    const result = await deleteRequest<{}>({
      url: "counter/results",
    });

    if (result.status === 200) {
      setresp([]);
    }
  };

  useEffect(() => {
    const interval = setInterval(async () => {
      const result = await getRequest<any>({
        url: "counter/results",
      });
      setresp(result.data);
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, []);
  return (<div>
    <h1> Debug </h1>
    <Button onClick={clearData} label="CLEAR" />
    {resp.map(({ date, request, response }) => {
      return (<div className={style["wrapper"]}>
          <h3> {date} </h3>
          <pre>
            {JSON.stringify(request, undefined, 2)}
          </pre>
          <pre>
            {JSON.stringify(response, undefined, 2)}
          </pre>
      </div>);
    })}
  </div>);
};

export default compose(
  withAuth(10),
  withTitle("Debug"),
)(Debug);
